<template>
  <div id="main-content">
    <div class="container-fluid">
      <div class="block-header">
        <BreadCrumb />
      </div>
      <div class="row clearfix">
        <!-- Line Chart for Mean PFL -->
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="body">
              <v-chart class="chart" :option="malePFLChart" autoresize />
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="body">
              <v-chart class="chart" :option="femalePFLChart" autoresize />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/plugins/echarts";
import BreadCrumb from "@/components/BreadCrumb.vue";
export default {
  name: "AnalyticalData",
  components: {
    BreadCrumb,
  },
  data() {
    return {
      meanPFLChart: {
        title: {
          text: "Mean Palpebral Fissure Length (PFL) Over Age Range",
          left: "center",
          top: "10px",
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}<br/>Male Mean PFL: {c0}<br/>Female Mean PFL: {c1}",
        },
        legend: {
          data: ["Male Mean PFL", "Female Mean PFL"],
          top: "30px",
        },
        xAxis: {
          type: "category",
          data: Array.from({ length: 18 }, (_, i) => i + 3),
          name: "Age",
          nameLocation: "middle",
          nameGap: 20,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "Mean PFL",
          min: 20,
          max: 34,
          interval: 2,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        series: [
          {
            name: "Male Mean PFL",
            type: "line",
            data: [
              23.27912, 23.85392, 24.41, 24.94412, 25.45352, 25.93592, 26.38951,
              26.813, 27.20552, 27.56672, 27.89672, 28.19612, 28.466, 28.7079,
              28.92392, 29.11652, 29.28871, 29.444,
            ],
            smooth: true,
            lineStyle: {
              color: "#00aaff",
            },
            itemStyle: {
              color: "#00aaff",
            },
          },
          {
            name: "Female Mean PFL",
            type: "line",
            data: [
              23.3216, 23.7212, 24.126, 24.53239, 24.9368, 25.3355, 25.72519,
              26.101, 26.46239, 26.8027, 27.119, 27.409, 27.6679, 27.8923,
              28.0787, 28.2235, 28.3231, 28.3739,
            ],
            smooth: true,
            lineStyle: {
              color: "#ff66cc",
            },
            itemStyle: {
              color: "#ff66cc",
            },
          },
        ],
      },

      malePFLChart: {
        title: {
          text: "Male Mean Palpebral Fissure Length (PFL) Over Age Range",
          left: "center",
          top: "10px",
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}<br/>Male Mean PFL: {c}",
        },
        legend: {
          data: ["Male Mean PFL"],
          top: "30px",
        },
        xAxis: {
          type: "category",
          data: Array.from({ length: 18 }, (_, i) => i + 3),
          name: "Age",
          nameLocation: "middle",
          nameGap: 20,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "Mean PFL",
          min: 20,
          max: 34,
          interval: 2,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        series: [
          {
            name: "Male Mean PFL",
            type: "line",
            data: [
              23.27912, 23.85392, 24.41, 24.94412, 25.45352, 25.93592, 26.38951,
              26.813, 27.20552, 27.56672, 27.89672, 28.19612, 28.466, 28.7079,
              28.92392, 29.11652, 29.28871, 29.444,
            ],
            smooth: true,
            lineStyle: {
              color: "#00aaff",
            },
            itemStyle: {
              color: "#00aaff",
            },
          },
        ],
      },
      femalePFLChart: {
        title: {
          text: "Female Mean Palpebral Fissure Length (PFL) Over Age Range",
          left: "center",
          top: "10px",
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}<br/>Female Mean PFL: {c}",
        },
        legend: {
          data: ["Female Mean PFL"],
          top: "30px",
        },
        xAxis: {
          type: "category",
          data: Array.from({ length: 18 }, (_, i) => i + 3),
          name: "Age",
          nameLocation: "middle",
          nameGap: 20,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "Mean PFL",
          min: 20,
          max: 34,
          interval: 2,
          axisLabel: {
            color: "#333",
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
        },
        series: [
          {
            name: "Female Mean PFL",
            type: "line",
            data: [
              23.3216, 23.7212, 24.126, 24.53239, 24.9368, 25.3355, 25.72519,
              26.101, 26.46239, 26.8027, 27.119, 27.409, 27.6679, 27.8923,
              28.0787, 28.2235, 28.3231, 28.3739,
            ],
            smooth: true,
            lineStyle: {
              color: "#ff66cc",
            },
            itemStyle: {
              color: "#ff66cc",
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.chart {
  height: 350px;
}
</style>
